/*
 * Public API Surface of core-plugin
 */

// DEFAULT
export * from './core-plugin.service';
export * from './core-plugin-initializer';


// USER AVATAR COMPONENT
export * from './administration/navbar-menu-item/global-settings/components/user-avatar/user-avatar.component';
